import React from 'react'
import { TableColumn } from '../../../components/_EOS/GenericTable'
import { Zone } from '../../../interfaces'
import { YesNoBadge } from '../../../components/YesNoBadge'

export const getColumnsConfig = (): TableColumn<Zone>[] => [
  { key: 'zoneName', title: 'Nombre Zona', sortable: true },
  {
    key: 'warehouse',
    title: 'Almacén',
    render: (value) => (value as Zone['warehouse'])?.warehouseName || 'Sin Almacén'
  },
  {
    key: 'active',
    title: 'Estado',
    render: (value) => (
      <YesNoBadge value={value as boolean} yesText='Activo' noText='Inactivo' />
    )
  },
  {
    key: 'externalStorage',
    title: 'Externa',
    render: (value) => <YesNoBadge value={value as boolean} />
  }
]
